export type UserReportData = {
  id: string;
  reportedUser: {
    name: string;
    email: string;
    type: "Mentor" | "Mentee";
  };
  reportedBy: {
    name: string;
    email: string;
    type: "Mentor" | "Mentee";
  } | null;
  submitter: "User" | "LLM";
  reportType: "Inappropriate Behavior" | "Harassment" | "Spam" | "Fraud" | "No Show" | "Other";
  description: string;
  dateReported: string;
  status: "Pending" | "Resolved";
};

const tableDataUserReports: UserReportData[] = [
  {
    id: "LT-2025-0120-4A8B",
    reportedUser: {
      name: "Michael Anderson",
      email: "michael.anderson@techcorp.com",
      type: "Mentor"
    },
    reportedBy: null,
    submitter: "LLM",
    reportType: "Inappropriate Behavior",
    description: "Natural language processing detected inappropriate personal questions and unprofessional communication patterns in mentor messages.",
    dateReported: "Jan 20, 2025",
    status: "Pending"
  },
  {
    id: "LT-2025-0118-7C2F",
    reportedUser: {
      name: "Jessica Chen",
      email: "j.chen@startup.io",
      type: "Mentee"
    },
    reportedBy: null,
    submitter: "LLM",
    reportType: "No Show",
    description: "Automated attendance tracking flagged pattern of consecutive no-shows without communication. System detected 4 missed sessions.",
    dateReported: "Jan 18, 2025",
    status: "Resolved"
  },
  {
    id: "LT-2025-0122-9E5D",
    reportedUser: {
      name: "Robert Thompson",
      email: "r.thompson@finance.co",
      type: "Mentor"
    },
    reportedBy: null,
    submitter: "LLM",
    reportType: "Fraud",
    description: "Automated detection flagged multiple messages requesting payment outside platform. AI identified potential fraud patterns in mentor-mentee communications.",
    dateReported: "Jan 22, 2025",
    status: "Pending"
  },
  {
    id: "LT-2025-0119-3B6A",
    reportedUser: {
      name: "Lisa Williams",
      email: "lisa.w@marketing.net",
      type: "Mentee"
    },
    reportedBy: null,
    submitter: "LLM",
    reportType: "Spam",
    description: "Spam detection algorithm identified multiple promotional messages and commercial solicitation attempts in mentorship communications.",
    dateReported: "Jan 19, 2025",
    status: "Pending"
  },
  {
    id: "LT-2025-0121-8F1C",
    reportedUser: {
      name: "Alex Johnson",
      email: "alex.j@developer.dev",
      type: "Mentor"
    },
    reportedBy: {
      name: "Maria Garcia",
      email: "maria.garcia@student.edu",
      type: "Mentee"
    },
    submitter: "User",
    reportType: "Inappropriate Behavior",
    description: "Mentor has been asking personal questions unrelated to mentorship and making me feel uncomfortable during our sessions.",
    dateReported: "Jan 21, 2025",
    status: "Pending"
  },
  {
    id: "LT-2025-0117-2D4E",
    reportedUser: {
      name: "Kevin Lee",
      email: "kevin.lee@business.com",
      type: "Mentee"
    },
    reportedBy: null,
    submitter: "LLM",
    reportType: "Other",
    description: "Pattern analysis detected repeated negative feedback and session cancellations. AI flagged potential mentorship engagement issues.",
    dateReported: "Jan 17, 2025",
    status: "Resolved"
  }
];

export default tableDataUserReports;